import { LogLevel } from '@nts/std/utility';

export const environment = {
    production: true,
    baseAppUrl: 'https://ntslogisticwebapp.ntsinformatica.it',
    authenticationAppUrl: 'https://ntsloginservice.ntsinformatica.it/auth/login',
    prefixApi: '/api',
    envType: 'DEV',
    appTitle: 'WebLogistic - DEV',
    appSubTitle: '',
    logLevel: LogLevel.All,
    isEnterpriseBarrierRequired: true
};
